import { first } from '@ckeditor/ckeditor5-utils';
export function upcastVideoFigure(videoUtils) {
    const converter = (evt, data, conversionApi) => {
        if (!conversionApi.consumable.test(data.viewItem, { name: true, classes: 'video' })) {
            return;
        }
        // Find an image element inside the figure element.
        const viewVideo = videoUtils.findViewVideoElement(data.viewItem);
        if (!viewVideo || !viewVideo.hasAttribute('src') || !conversionApi.consumable.test(viewVideo, { name: true })) {
            return;
        }
        conversionApi.consumable.consume(data.viewItem, { name: true, classes: 'video' });
        const conversionResult = conversionApi.convertItem(viewVideo, data.modelCursor);
        const modelVideo = first(conversionResult.modelRange.getItems());
        // When video wasn't successfully converted then finish conversion.
        if (!modelVideo) {
            // Revert consumed figure so other features can convert it.
            conversionApi.consumable.revert(data.viewItem, { name: true, classes: 'video' });
            return;
        }
        // Convert rest of the figure element's children as an video children.
        conversionApi.convertChildren(data.viewItem, modelVideo);
        conversionApi.updateConversionResult(modelVideo, data);
    };
    return dispatcher => {
        dispatcher.on('element:figure', converter);
    };
}
export function downcastVideoAttribute(videoUtils, videoType, attributeKey) {
    const converter = (evt, data, conversionApi) => {
        if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
        }
        const writer = conversionApi.writer;
        const element = conversionApi.mapper.toViewElement(data.item);
        const video = videoUtils.findViewVideoElement(element);
        writer.setAttribute(data.attributeKey, data.attributeNewValue || '', video);
    };
    return dispatcher => {
        dispatcher.on(`attribute:${attributeKey}:${videoType}`, converter);
    };
}
//# sourceMappingURL=converters.js.map